import styled from '@emotion/styled';

export const DashboardFilters = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const FilterItem = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const SelectSide = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
`;
